import { Section } from '@/components/shared';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { faqs } from '../constants';
import type { ISectionItem } from '../types';

const FaqItem: React.FC<ISectionItem> = (props): JSX.Element => {
  const { content, title } = props;
  return (
    <AccordionItem>
      <AccordionButton>
        <Box flex="1" textAlign="left">
          <h2>{title}</h2>
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel>{content}</AccordionPanel>
    </AccordionItem>
  );
};

export const Faq: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Section
      headingProps={{ mt: { base: 12, md: '120px' } }}
      id="faq"
      title={t('LANDING.FAQ.SECTION_TITLE')}
    >
      <Container maxW="container.lg" px={{ base: 0 }}>
        <Accordion allowToggle>
          {faqs.map(({ content, title, ...rest }) => (
            <FaqItem content={t(content)} key={`faq-${rest.id}`} title={t(title)} {...rest} />
          ))}
        </Accordion>
      </Container>
    </Section>
  );
};
